import { LOAN_REQUEST_OFFER_BANKS } from 'cpool-constants';

import { useBanks } from '~/features/leadList/hooks/useBanks';

const isRecordableBank = (acronym: string | null): acronym is keyof typeof LOAN_REQUEST_OFFER_BANKS =>
    acronym !== null && acronym in LOAN_REQUEST_OFFER_BANKS;

// Labels come from the Banks read model (acronym -> full name); the stored value stays the acronym, falling back to it if unresolved.
export const useOfferBankOptions = () => {
    const { data: banks } = useBanks();

    const resolvedNames = new Map(
        (banks ?? [])
            .filter((bank) => isRecordableBank(bank.acronym))
            .map((bank) => [bank.acronym as string, bank.fullname] as const),
    );

    return Object.values(LOAN_REQUEST_OFFER_BANKS)
        .map((acronym) => ({ label: resolvedNames.get(acronym) ?? acronym, value: acronym }))
        .sort((a, b) => a.label.localeCompare(b.label));
};
